export default __webpack_public_path__ + "static/media/emblema_PURP_3D.ee64e886.png";